import { render } from "./AppPostBlock.html?vue&type=template&id=e8d976b2"
import script from "./AppPostBlock.js?vue&type=script&lang=js"
export * from "./AppPostBlock.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__